"use client";

import { P } from "@/components/ui/Heading";
import { Link } from "@/i18n/routing";
import { ChevronLeftCircleIcon, ChevronRightCircleIcon } from "lucide-react";
import Image from "next/image";
import { useParams } from "next/navigation";
interface CommunityLifestyleCardProps {
  image: string;
  title: string;
  location: string;
  link: string;
}

export const CommunityLifestyleCard = ({
  image,
  link,
  location,
  title,
}: CommunityLifestyleCardProps) => {
  const { locale } = useParams();

  return (
    <Link href={`/listing/${link}`}>
      <div className="border rounded-lg p-4 space-y-2 hover:bg-gray-200/40 transition-all cursor-pointer group">
        <div className="relative h-52 w-full">
          <Image
            src={image}
            alt={`${location}-${title}`}
            fill
            className="rounded-lg object-cover object-top"
            sizes="(max-width: 768px) 80vw, 30vw"
          />
        </div>

        <div className="flex items-center gap-1 text-primary justify-between">
          <div className="inline-flex items-center gap-1 ">
            <div>
              <P className="text-sm text-gray-800">{title}</P>
              <P className="font-semibold text-base text-gray-800 line-clamp-1">
                {location}
              </P>
            </div>
          </div>
          {locale == "en" ? (
            <ChevronRightCircleIcon className="size-5 !font-light mr-2 group-hover:-mr-1 transition-all" />
          ) : (
            <ChevronLeftCircleIcon className="size-5 !font-light ml-2 group-hover:-ml-1 transition-all" />
          )}
        </div>
      </div>
    </Link>
  );
};
